import React, { useEffect, useState, useRef } from 'react'
import ReactDOM from 'react-dom'
import { message } from 'antd'
import { useLockFn } from 'ahooks'
import { cdnImg } from '../../../utils/image'
import Modal from '../../modal'
import request from '../../../utils/request'
import FileTreeData from '../../../common/fileTreeData'
import { message as mes } from '../../../utils'
import Icon from '../../icon'
import globalData from '../../../common/globalData'
import TreeOption from '../../inspirationTreeList'
import Button from '../../../baseComponent/button'
import styles from './index.module.less'

export default ({ className, style, onClickTrigger, blogs, blogId, blogIds, fromInspirationId, onChange }) => {
  const _onClickTrigger = (e) => {
    e && e.stopPropagation()
    renderMoveImage({
      blogs,
      blogIds,
      onChange,
      fromInspirationId
    })
    onClickTrigger?.()
  }
  return <Button
    className={className}
    style={style}
    onClick={_onClickTrigger}
    disabled={!blogId && !blogIds.length}
    type="primary"
  >移动</Button>
}

export const renderMoveImage = (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<MoveImage {...props} visible container={div} />, div)
  })
}

const MoveImage = ({
  visible,
  blogId,
  blogs = [],
  blog = {},
  fromInspirationId,
  hasMove = true,
  url = '/zhikuan/ins/inspiration/move-blogs-to-inspiration', // /update-quick-collect-inspiration
  onCancel,
  onOk,
  onChange
}) => {
  const [_visible, set_Visible] = useState(visible)
  const [treeOption, setTreeOption] = useState([])
  const [loading, setLoading] = useState(false)
  //
  const [repeatIds, setRepeatIds] = useState([])
  const [repeatVisible, setRepeatVisible] = useState(false)
  const [repeatIndex, setRepeatIndex] = useState(0)
  const [toIdeaMass, setToIdeaMass] = useState({})
  //
  const [hasReserveValue, setHasReserveValue] = useState(false)
  //
  const treeData = useRef(null)

  const [keyWords, setKeyWords] = useState()
  const pageParams = useRef({
    start: 0,
    pageSize: 20
  })
  const resultList = useRef([])
  const totalRef = useRef(0)
  useEffect(() => {
    globalData.toGet('move-image-has-reserve').then(result => {
      if (result) {
        setHasReserveValue(JSON.parse(result))
      }
    })
  }, [])

  useEffect(() => {
    if (!visible) {
      setRepeatIndex(0)
    }
  }, [visible])

  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }
  const _ok = async () => {
    const flag = await onOk?.()
    if (flag === false) {
      return
    }
    set_Visible(false)
  }

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async (
    _keyWords = keyWords,
    _pageParams = pageParams.current,
  ) => {
    setLoading(true)
    const res = await request.post('/zhikuan/ins/inspiration/list-collect-inspiration-tree', {
      ..._pageParams,
      likeName: _keyWords,
    })
    totalRef.current = res.resultCount
    const tempResult = _pageParams.start === 0 ? resultList.current = res.resultList : resultList.current = [...resultList.current, ...res.resultList]
    treeData.current = new FileTreeData({
      data: tempResult,
      childrenKey: 'childs',
    })
    treeData.current.checkMoveAllMarkStatus(fromInspirationId)
    setTreeOption(treeData.current.data)
    setLoading(false)
  }

  // 重复替换
  const fetchRepeat = async (toInspirationId) => {
    try {
      const res = await request.post('/zhikuan/ins/inspiration/query-blog-is-collect', { blogIdList: blogId ? [blogId] : blogs.map(m => m.imageGroupEntityId), inspirationId: toInspirationId })
      setRepeatIds(res)
      return res
    } catch (err) {
      console.error('query-blog-is-collect', err)
    }
  }

  const replace = async (id) => {
    setRepeatIds(pre => pre.filter(m => m !== id))
    let blogParamList = blogId ? [{ blogId, fromInspirationId }]
      : blogs.map(m => ({ blogId: m.imageGroupEntityId, fromInspirationId: m.inspirationId }))
    blogParamList = blogParamList.filter(m => m.blogId === id)
    try {
      await request.post(url, {
        blogParamList,
        toInspirationId: toIdeaMass.id,
        copy: hasMove ? hasReserveValue ? 1 : 0 : null
      })
      if (repeatIds.length === 1) {
        setRepeatVisible(false)
        const flag = includeNode(toIdeaMass.id, fromInspirationId)
        onChange && onChange(blogId, flag, hasReserveValue)
        message.success(<span>已成功移动至<a
          className="mn-link"
          href={`/meinian/home/coll/detail/${toIdeaMass.id}?inspirationId=${toIdeaMass.id}`}
          target="_blank"
          rel="noreferrer"
        >{toIdeaMass.name}</a></span>)
      }
    } catch (err) {
      console.error('move-blogs-to-inspiration', err)
    }
  }

  const replaceAll = async () => {
    let blogParamList = blogId ? [{ blogId, fromInspirationId }]
      : blogs.map(m => ({ blogId: m.imageGroupEntityId, fromInspirationId: m.inspirationId }))
    blogParamList = blogParamList.filter(m => repeatIds.includes(m.blogId))
    try {
      await request.post(url, {
        blogParamList,
        toInspirationId: toIdeaMass.id,
        copy: hasMove ? hasReserveValue ? 1 : 0 : null
      })
      setRepeatVisible(false)
      const flag = includeNode(toIdeaMass.id, fromInspirationId)
      onChange && onChange(blogId, flag, hasReserveValue)
      message.success(<span>已成功移动至<a className="mn-link" href={`/meinian/home/coll/detail/${toIdeaMass.id}?inspirationId=${toIdeaMass.id}`} target="_blank" rel="noreferrer">{toIdeaMass.name}</a></span>)
    } catch (err) {
      console.error('move-blogs-to-inspiration', err)
    }
  }

  // eslint-disable-next-line default-param-last
  const move = async (_repeatIds = [], toInspirationId) => {
    let blogParamList = blogId ? [{ blogId, fromInspirationId }]
      : blogs.map(m => ({ blogId: m.imageGroupEntityId, fromInspirationId: m.inspirationId }))
    if (_repeatIds.length) {
      blogParamList = blogParamList.filter(m => !_repeatIds.includes(m.blogId))
    }
    if (!blogParamList.length) { return }
    try {
      await request.post(url, {
        blogParamList,
        toInspirationId,
        copy: hasMove ? hasReserveValue ? 1 : 0 : null
      })
    } catch (err) {
      console.error('move-blogs-to-inspiration', err)
      return err
    }
  }

  const onMove = useLockFn(async (toInspiration) => {
    const ids = await fetchRepeat(toInspiration.id)
    const moveRes = await move(ids, toInspiration.id)
    if (moveRes) {
      mes.pub('onMNUploadImage')
      set_Visible(false)
      return message.warning(moveRes?.errorDesc)
    }
    if (ids.length) {
      setToIdeaMass(toInspiration)
      setRepeatVisible(true)
      set_Visible(false)
      return
    }
    const curItem = treeData.current.findNodeByValue(toInspiration.id)
    let linkUrl = ''
    if (curItem.parent) {
      linkUrl = `/meinian/home/coll/detail/${toInspiration.id}?inspirationId=${toInspiration.id}&parentId=${curItem.parent.value}&name=${curItem.current.label}`
    } else {
      linkUrl = `/meinian/home/coll/detail/${toInspiration.id}?inspirationId=${toInspiration.id}`
    }
    message.success(<span>已成功移动至<a
      className="mn-link"
      href={linkUrl}
      target="_blank"
      rel="noreferrer"
    >{toInspiration.name}</a></span>)
    const flag = includeNode(toInspiration.id, fromInspirationId)
    onChange && onChange(blogId, flag, hasReserveValue)
    set_Visible(false)
  })

  const includeNode = (toInspirationId, _fromInspirationId) => {
    const root = treeData.current.getRootByValue(_fromInspirationId)
    if (toInspirationId === root.value) {
      return true
    }
    const flag = treeData.current.someIsChild(toInspirationId, root.value)
    return flag
  }

  return <>
    <Modal
      onCancel={_cancel}
      onOk={_ok}
      visible={_visible}
      style={{ width: '640px', borderRadius: '3px' }}
      title={<span style={{ fontSize: 20, color: 'var(--m-text-1)' }}>移动到灵感集</span>}
      hiddenFooter
      className={styles['mn-move-image-modal']}
    >
      <div className={styles['move-image-modal-content']}>
        <TreeOption
          onLoad={() => {
            pageParams.current.start += 20
            if (pageParams.current.start < totalRef.current) {
              fetchData()
            }
          }}
          keyWords={keyWords}
          onKeyWords={(val) => {
            pageParams.current.start = 0
            fetchData(val)
            setKeyWords(val)
          }}
          collectBtn="移动"
          singleCollection
          hasMove={hasMove}
          hasReserveValue={hasReserveValue}
          hasCollectChange={false}
          onHasReserveChange={(e) => {
            globalData.set('move-image-has-reserve', e.target.checked)
            setHasReserveValue(e.target.checked)
          }}
          onItemCollect={(inspirationId, inspiration) => onMove(inspiration)}
          onChooseTaskClose={_cancel}
          onChooseTaskOk={_cancel}
          onCancel={_cancel}
          treeData={treeData.current}
          data={treeOption}
          scrollHeight="calc(100vh - 282px)"
          loading={loading}
          onCreateInspiration={(_id, _name, _current) => onMove(_current)}
        />
      </div>
    </Modal>
    {repeatVisible ? <Modal
      visible={repeatVisible}
      onVisibleChange={_repeatVisible => setRepeatVisible(_repeatVisible)}
      onClose={() => onChange?.(blogId, false, hasReserveValue)}
      title={<><Icon type="m-zhuyi_tianchong" style={{ color: '#ED7E28' }} />提醒</>}
      style={{ width: 480 }}
      footer={<>
        <Button ghost style={{ width: 88 }} onClick={() => { setRepeatVisible(false) }}>取消</Button>
        {!blogId ? <Button ghost style={{ marginLeft: 8 }} onClick={() => replaceAll()}>全部替换</Button> : null}
        {!blogId && repeatIndex < repeatIds.length - 1
          ? <Button
              ghost
              style={{ width: 88, marginLeft: 8 }}
              onClick={() => setRepeatIds(pre => pre.filter(m => m !== repeatIds[repeatIndex]))}
          >下一个</Button> : null}
        <Button other style={{ width: 88, marginLeft: 8 }} onClick={() => replace(repeatIds[repeatIndex])}>替换</Button>
      </>}
    >
      <div className={styles['mn-move-image-repeat']}>
        <div className="text">该灵感集中已经存在相同的款式图，你要使用正在移动的款式图来替换它吗？选择替换后，相关的批注、评论及款式升级信息均会以新款式图的信息为准。</div>
        <div className="images">
          {repeatIndex + 2 > repeatIds.length - 1 ? null : <div className="image-3"><img src={cdnImg(blog?.mainUrl || blogs.find(m => m.imageGroupEntityId === repeatIds[repeatIndex + 2])?.mainUrl, 200)} /></div>}
          {repeatIndex + 1 > repeatIds.length - 1 ? null : <div className="image-2"><img src={cdnImg(blog?.mainUrl || blogs.find(m => m.imageGroupEntityId === repeatIds[repeatIndex + 1])?.mainUrl, 200)} /></div>}
          {repeatIndex > repeatIds.length - 1 ? null : <img className="image-1" style={{ right: blogId ? 136 : 88 }} src={blog?.mainUrl || blogs.find(m => m.imageGroupEntityId === repeatIds[repeatIndex])?.mainUrl} /> }
        </div>
      </div>
    </Modal> : null}
  </>
}
